import React from "react";
import { Link, useParams } from "react-router-dom";
import PricingHero from "../../PricingHero/pricingHero";
import PricingImg1 from "../../../assets/pricingadvertisingimg.png";
import PricingImg2 from "../../../assets/servicessoftware1.png";
import PricingImg3 from "../../../assets/Item6.png";
import "./PricingSection1.css";
import { useTranslation } from "react-i18next";

const PricingSection1 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="bg" style={{ padding: "15px 100px" }}>
      <PricingHero />
      <section className="pricing-section2">
        <article className="pricing-card">
          <figure>
            <img
              className="pricing-card-image"
              src={PricingImg1}
              alt="Advertising and Media Services"
            />
          </figure>
          <h2>{t("pricing-section1.heading")}</h2>
          <p>{t("pricing-section1.text")}</p>

          <Link to={`/${lang}/Pricing/Marketing`} onClick={scrollToTop}>
            <button className="pricing-button">
              {t("pricing-section1.button")}
            </button>
          </Link>
        </article>
        <article className="pricing-card">
          <figure>
            <img
              className="pricing-card-image"
              src={PricingImg3}
              alt="Creative Design Services"
            />
          </figure>
          <h2>{t("pricing-section1.heading2")}</h2>
          <p>{t("pricing-section1.text2")}</p>

          <Link to={`/${lang}/Pricing/Creative`} onClick={scrollToTop}>
            <button className="pricing-button">
              {t("pricing-section1.button")}
            </button>
          </Link>
        </article>
      </section>
      <section className="pricing-section2">
        <article className="pricing-card-bottom">
          <figure>
            <img
              className="pricing-card-image"
              src={PricingImg2}
              alt="Software Solution Services"
            />
          </figure>
          <h2>{t("pricing-section1.heading3")}</h2>
          <p>{t("pricing-section1.text3")}</p>

          <Link to={`/${lang}/Pricing/Software`} onClick={scrollToTop}>
            <button
              className="pricing-button pricing-button-bottom">
              {t("pricing-section1.button")}
            </button>
          </Link>
        </article>
      </section>
    </section>
  );
};

export default PricingSection1;
